import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  loading: false,
  loaded: null,
  error: false,
  data: null,
  notice: null,
};

// Slice
const noticeDetailSlice = createSlice({
  name: "noticeDetail",
  initialState,
  reducers: {
    getNoticeDetail(state) {
      return { ...state, loading: true, error: false };
    },
    setNoticeDetail(state, action) {
      const notice = action.payload;
      return {
        ...state,
        notice,
      };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const {
  getNoticeDetail,
  setNoticeDetail,
  fetchDataSuccess,
  fetchDataFailure,
} = noticeDetailSlice.actions;

export default noticeDetailSlice.reducer;

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl, data } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });

    const response = yield call(apiService.post, apiUrl, data);
    yield put(fetchDataSuccess(response.data));
    if (response?.data) {
      const { code, data } = response.data;
      if (code === "0200") {
        const notice = data;
        yield put(setNoticeDetail(notice));
      }
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* noticeDetailSaga() {
  yield takeLatest(getNoticeDetail.type, fetchDataSaga);
}
